module.exports = __webpack_public_path__ + "imgs/facebook-color.04350a8e2c4cc80ec7999df225348ec6.svg";